import { render, staticRenderFns } from "./CatalogMenu.vue?vue&type=template&id=43863043&scoped=true"
import script from "./CatalogMenu.vue?vue&type=script&lang=js"
export * from "./CatalogMenu.vue?vue&type=script&lang=js"
import style0 from "./CatalogMenu.vue?vue&type=style&index=0&id=43863043&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43863043",
  null
  
)

export default component.exports